import axiosInstance from '../config/axios.js';

const API_BASE = '/analytics';

const analyticsService = {
  // Get Profit & Loss Analytics
  getProfitLoss: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/profit-loss`, { params });
    return response.data;
  },

  // Get Shipment Analytics
  getShipmentAnalytics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/shipments`, { params });
    return response.data;
  },

  // Get Vehicle Analytics
  getVehicleAnalytics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/vehicles`, { params });
    return response.data;
  },

  // Get Missing & Returned Analytics
  getMissingReturnedAnalytics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/missing-returned`, { params });
    return response.data;
  },

  // Get User Performance Analytics
  getUserPerformance: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/user-performance`, { params });
    return response.data;
  },

  // Get Dashboard Summary
  getDashboardSummary: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/dashboard`, { params });
    return response.data;
  },

  getAgentNetworkAnalytics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/agent-network`, { params });
    return response.data;
  },

  // Get Inventory Analytics (NEW)
  getInventoryAnalytics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/inventory`, { params });
    return response.data;
  },

  // Get On Contract Analytics
  getOnContractAnalytics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/on-contracts`, { params });
    return response.data;
  },

  // Get Vehicle Contract Analytics
  getVehicleContractAnalytics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/vehicle-contracts`, { params });
    return response.data;
  },

  // Get Trip Contract Analytics
  getTripContractAnalytics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/trip-contract`, { params });
    return response.data;
  },

  // Get Shipment Commission Analytics
  getCommissionAnalytics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/commissions`, { params });
    return response.data;
  }
};

export default analyticsService;
